import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const customersApi = {
  async listPetOwners(params = {}) {
    const response = await apiClient.get("/pet-owners", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async getPetOwner(id) {
    const response = await apiClient.get(`/pet-owners/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async createPetOwner(payload) {
    const response = await apiClient.post("/pet-owners", payload);
    return unwrapEnvelope(response.data, null);
  },

  async updatePetOwner(id, payload) {
    const response = await apiClient.put(`/pet-owners/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async countPetOwners(params = {}) {
    const response = await apiClient.get("/pet-owners/count", { params });
    return unwrapEnvelope(response.data, { count: 0 });
  }
};
